export default function checkIfNew(id) {
  return !id || id === 'add'
}
